import logoJcjt from '@/assets/logo/logo.png'
let ENV_DIFF = import.meta.env.VITE_APP_DIFF_DOMIN
let title = import.meta.env.VITE_APP_COMPANY,logoUrl=logoJcjt
if(title&&title.includes('安徽建工检测科技')){
    logoUrl = logoJcjt
}
const config_dev = {
    serveUrl:"/jcjt-pms", ///jcjt-pms-wlk
    auth_url:"/lqjcrbg-auth",
    file_url:"/jcjt-pms",
    fileOutSideUrl:`http://test.jckj.group/api/jcjt-pms`,
    //fileOutSideUrl:`https://mis.jckj.group/api/jcjt-file`,
    // fileOutSideUrl:`http://172.16.13.75:9999/lgtjc-file`,
    //reportUrl:"http://test.jckj.group/uReport"
    //reportUrl:"http://test.jckj.group/uReport",
    reportUrl:"http://172.16.13.69:9527",
    outUrl:"http://172.16.13.69:5173/#",
    proUrl:"http://172.16.13.69:1002",
    lgtServe:"/jcjt",
    busiServe:"/jcjt-pms",
    parentServe:"/jcjt-api",
    sysType:"jcjt",//jcjt  lgt
    logoUrl:logoUrl
}
const config_test = {
    serveUrl:"/jcjt-pms",//lcjt-pms
    file_url:"/jcjt-pms",
    fileOutSideUrl:`http://test.jckj.group/api/jcjt-pms`,
    //fileOutSideUrl:`https://mis.jckj.group/api/jcjt-file`,
    //fileOutSideUrl:`http://172.16.13.75:9999/jcjt-file`,
    reportUrl:"http://test.jckj.group/uReport",
    outUrl:"http://test.jckj.group/pms/#",
    proUrl:"http://test.jckj.group/customer",
    lgtServe:"/jcjt",
    busiServe:"/jcjt-pms",
    parentServe:"/jcjt-api",
    sysType:"jcjt",//jcjt  lgt
    logoUrl:logoUrl
    //reportUrl:"http://172.16.13.67:9528"
}

const config_ys = {
    serveUrl:"/lgtjc-pms-ys",//lcjt-pms
    file_url:"/lgtjc-pms-ys",
    fileOutSideUrl:`http://test.jckj.group/api/jcjt-pms`,
    //fileOutSideUrl:`https://mis.jckj.group/api/jcjt-file`,
    //fileOutSideUrl:`http://172.16.13.75:9999/jcjt-file`,
    reportUrl:"http://test.jckj.group/lgtjc-ys/uReport",
    outUrl:"http://test.jckj.group/lgtjc-ys/pms/#",
    lgtServe:"/lgtjc",
    sysType:"lgt",//jcjt  lgt
    //reportUrl:"http://172.16.13.67:9528"
}

const config_pro = {
    serveUrl:"/jcjt-pms",//jcjt-pms
    file_url:"/jcjt-pms",//jcjt-file
    busiServe:"/jcjt-pms",
    lgtServe:"/jcjt",

    fileOutSideUrl:`${ENV_DIFF}/api/jcjt-pms`,
    reportUrl:`${ENV_DIFF}/uReport`,
    outUrl:`${ENV_DIFF}/jcjt/pms/#`,
    proUrl:`${ENV_DIFF}`,
    parentServe:"/jcjt-api",
    sysType:"jcjt",//jcjt  lgt
    logoUrl:logoUrl
}                
let ENV = "pro";    
let config = null;
if(ENV=='pro'){
    config = config_pro
}else if(ENV == 'test'){
    //config = config_ys;

    config = config_test
}else{
    config = config_dev
    
}
export default config;


